import PropTypes from 'prop-types';
import React from 'react';
import UI from '../ui';
import Utils from '../utils';

const { Validation } = Utils;
const { WrappedInputTextWithLabel } = UI;

const socialMediaTypes = {
	Facebook: {
		iconClassName: 'pi-facebook',
		title: 'Facebook',
		hostName: 'https://www.facebook.com/',
	},
	Twitter: {
		iconClassName: 'pi-twitter',
		title: 'Twitter',
		hostName: 'https://www.twitter.com/',
	},
	Instagram: {
		iconClassName: 'instagram',
		title: 'Instagram',
		hostName: 'https://www.instagram.com/',
	},
	Pinterest: {
		iconClassName: 'pinterest',
		title: 'Pinterest',
		hostName: 'https://www.pinterest.com/',
	},
	Linkedin: {
		iconClassName: 'linkedin',
		title: 'LinkedIn',
		hostName: 'https://www.linkedin.com/company/',
	},
	Youtube: {
		iconClassName: 'youtube',
		title: 'YouTube',
		hostName: 'https://www.youtube.com/',
	},
};

const SocialMediaInput = ({ Url: url, className, onChange, Type: type }) => {
	const { iconClassName, title, hostName } = socialMediaTypes[type];
	const onBlur = event => {
		const { value } = event.target;
		// if user's page name only, then add social media host name
		const pageName = value.replace('/', '').trim();

		if (
			pageName &&
			!Validation.isValidUrl(pageName) &&
			Validation.isValidUrl(hostName + pageName)
		) {
			event.target.value = hostName + pageName;
			onChange(event);
		}
	};

	return (
		<WrappedInputTextWithLabel
			className={className}
			label={<>{title}</>}
			isInputInvalid={
				(url || '') !== '' && !Validation.isValidUrl(hostName + url)
			}
			errorMessage="The URL is badly formed or contains invalid characters"
			uiElementConfig={{
				value: (url || '').replace(hostName, '/'), // show page name only, skip host name
				className,
				onChange,
				onBlur,
				placeholder: '/username',
				maxLength: 100,
				dataqa: type,
				name: type,
			}}
		/>
	);
};

export default SocialMediaInput;

SocialMediaInput.propTypes = {
	className: PropTypes.string,
	onChange: PropTypes.func,
	Type: PropTypes.string,
	Url: PropTypes.string,
};
